/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import Line from "components/Placeholders/Line";
import { convertUTCToTimezoneWithOffset } from "utils/time";
import { selectors as JobDetailSelectors } from "store/modules/jobDetails";
import Can from "components/Authorization/Can";
import { PositionPermissions } from "helpers/constants/permissions";

export default function useAppliedDate(disabled) {
    const canAddWorker = useSelector(JobDetailSelectors.getCanAddWorkerInDashboard);
    return {
        Header: "Applied Date",
        id: "appliedDate",
        width: undefined,
        sortable: false,
        Cell: ({ row: { original: { createdAtUtc } } }) => {
            return (
                convertUTCToTimezoneWithOffset(createdAtUtc)
            );
        },
        Footer: (<Can perform={PositionPermissions.create.fill.value}>
            {allowed => {
                if (!allowed) {
                    return null;
                }
                return canAddWorker && !disabled ? <Line /> : null
            }}
        </Can>)
    };
}
